//@helpers
const { formatText } = require('core/i18n').i18n;
// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const { updateConsents } = require('actions/gdprConsents');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
  getCardStandard,
  getCreditCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { get } = require('lodash');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  API_CHANNEL,
  CREDIT_CARD_STANDARD_VIA_T,
  CREDIT_CARD_SUBTYPE_VIA_T,
  CREDIT_CARD_TYPE_VIA_T,
  SECOND_STEP,
} = require('constants/index');
const { VIA_T_CARD_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { CREDIT_CARD_REVOLVING_PROCESS, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_RESET,
  };
}
function resetDIR() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET,
  };
}
const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetDIR());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_VIA_T_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};

function onHandleChangeCheckBoxCC() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_SET_AGREEMENT_CHECKBOX_CC
  };
}

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function validateAccount() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_VALIDATE_ACCOUNT,
  };
}

function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_PROCCESS_EMAIL_SUCCESS,
  };
}

function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_PROCCESS_EMAIL_ERROR,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function hireCardViaTprintDocument() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_PRINT_DOCUMENT,
  };
}
function hireCardViaTprintDocumentPolicy() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_PRINT_DOCUMENT_POLICY,
  };
}
function hireCardViaTCheckedRadioButton(check) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_CHECK_RADIO_BUTTON,
    payload: {
      check,
    },
  };
}
function hireCardViaTCheckedRadioButtonPolicy(check) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_CHECK_RADIO_BUTTON_POLICY,
    payload: {
      check,
    },
  };
}

function validate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}

function newValidate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_NEW_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}

function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_AGREEINECHECKBOX,

  };
}
const hireCreditCardDocumentRead = (documentType) => {
  return {
    type: actionTypes.HIRE_CARD_VIAT_CARD_DOCUMENT_READ,
    payload: {
      documentType
    }
  }
}
const hireCreditCardAllDocumentRead = () => {
  return {
    type: actionTypes.HIRE_CARD_VIAT_CARD_ALL_DOCUMENT_READ
  }
}
const hireCreditCardsaveDocumentAccepted = (documentsList, dmsDocumentType, documentChanges) => {
  return {
    type: actionTypes.HIRE_CARD_VIAT_CARD_SAVE_DOCUMENT_ACCEPTED,
    payload: { documentsList, dmsDocumentType, documentChanges }
  }
}
function hireCardNerudaCheckedRadioButtonIneDir(check) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON_INE_DIR,
    payload: { documentsList, dmsDocumentType, documentChanges }

  };
}
const validateFirstAndFourthStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

  newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
    ? dispatch(newValidate(step, true, showIneAndRevolving))
    : dispatch(validate(step, true, showIneAndRevolving));

};

const validateSecondStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const accountIsValid = getState().hireCardViaT.getIn(['steps', step - 1, 'accountIsValid']);
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') < immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
      ? dispatch(newValidate(step, allComponentsAreValid))
      : dispatch(validate(step, allComponentsAreValid));
  }
};

const validateThirdStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const cardsFeatureFlag = getState().flagBasedFeatures;

  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    if (step === 3) {
      newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
        ? dispatch(newValidate(step, allComponentsAreValid))
        : dispatch(validate(step, allComponentsAreValid));
    } else {
      __CONTACT_CENTER__ && !isPrintOfficeMode()
        ? dispatch(validate(step, allComponentsAreValid))
        : dispatch(newValidate(step, allComponentsAreValid));
    }
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    if (step === 3) {
      newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
        ? dispatch(newValidate(step, allComponentsAreValid))
        : dispatch(validate(step, allComponentsAreValid));
    } else {
      __CONTACT_CENTER__ && !isPrintOfficeMode()
        ? dispatch(validate(step, allComponentsAreValid))
        : dispatch(newValidate(step, allComponentsAreValid));
    }
  }
};

const validateINEStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const cardsFeatureFlag = getState().flagBasedFeatures;

  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardViaT = getState().hireCardViaT
  const documentINE = immHireCardViaT.get('documentINE')
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
      ? dispatch(newValidate(step, allComponentsAreValid))
      : dispatch(validate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardViaT));
  } else {
    newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode())
      ? dispatch(newValidate(step, allComponentsAreValid))
      : dispatch(validate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardViaT));
  }
};
const validateINEDIRStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardViaT = getState().hireCardViaT
  const documentINE = immHireCardViaT.get('documentINE')

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(newValidate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireCardViaT));
  } else {
    dispatch(newValidate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireCardViaT));
  }
};

const validatePolicyStep = () => (dispatch, getState) => {
  const immHireCardViaT = getState().hireCardViaT
  const documentPolicy = immHireCardViaT.get('documentPolicy')
  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireCardViaT));
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardViaT.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const hireCardViaT = getState().hireCardViaT;
  const hireCreditCard = getState().hireCreditCard;

  const documentId = hireCardViaT.get('documentId');
  const operationProcessIdInit = hireCardViaT.get('operationProcessIdInit');

  let acceptanceText;
  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    acceptanceText = 'NA'
  }
  if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
  }
  if (!__CONTACT_CENTER__) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
  }
  const documentIdDIR = hireCreditCard.get('documentIdDIR')

  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      documents: [
        {
          documentId: hireCardViaT.get('documentIdINE'),
          scrollDown: true,
        },
        ...(documentIdDIR ? [{
          documentId: documentIdDIR,
          scrollDown: true,
        }] : [])
      ],
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());
      }
    });

};

const validateStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures;
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
  const immHireCreditCard = getState().hireCreditCard;
  const policyDocument = immHireCreditCard.get('documentPolicy')
  if (newCardsFF) {
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardViaTFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        //SECOND_STEP
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        //THIRD_STEP
        dispatch(validateThirdStep(step))
        dispatch(validateINEStep(step))
          .then(() => {
            dispatch(validatePolicyStep());
          })
      } else if (step === 1 || step === 4) {
        //FIRST_STEP AND FIFTH_STEP
        dispatch(validateFirstAndFourthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    } else {
      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(newValidate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(newValidate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardViaTFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        //SECOND_STEP
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        dispatch(validateINEDIRStep(step));
      } else if (step === 4) {

        !policyDocument && dispatch(processEmail())
          .then(() => {
            dispatch(validatePolicyStep());
          })
        dispatch(validateThirdStep(step));
        !isPrintOfficeMode() && dispatch(agreeIneCheckbox())
      } else if (step === 1 || step === 5) {
        //FIRST_STEP AND FIFTH_STEP
        dispatch(validateFirstAndFourthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    }
  } else {
    if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardViaTFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === 2) {
      //SECOND_STEP
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 3) {
      //THIRD_STEP
      dispatch(validateThirdStep(step));
    } else if (step === 1 || step === 4) {
      //FIRST_STEP AND FIFTH_STEP
      dispatch(validateFirstAndFourthStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));
  }
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_VIA_T_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardViaTRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardViaTFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardViaTSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              VIA_T_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(VIA_T_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardViaTFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardViaTFailure());
      } else {
        throw response;
      }
    });
};

const myCardsTarjetasHire = () => (dispatch, getState) => {
  const hireCardViaT = getState().hireCardViaT;
  const callback = (dispatch, getState, dataToken) => {

    const contractNumberAccount = hireCardViaT.get('contractNumberAccount');
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA' : formatText('hireCreditCard-textInfoIneDir')

    const data = {
      processType: 'contract',
      documentId: hireCardViaT.get('documentIdPolicy'),
      operationProcessId: hireCardViaT.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: CREDIT_CARD_SUBTYPE_VIA_T,
          tipo: CREDIT_CARD_TYPE_VIA_T,
          standard: CREDIT_CARD_STANDARD_VIA_T,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: hireCardViaT.get('scrollDownPolicy'),
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_VIA_T,
        type: CREDIT_CARD_TYPE_VIA_T,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setCardViaT(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCardViaTCheckedRadioButton(check));
}

const checkRadioButtonPolicy = (check) => (dispatch, getState) => {
  dispatch(hireCardViaTCheckedRadioButtonPolicy(check));
}

const printDocument = () => (dispatch, getState) => {
  dispatch(hireCardViaTprintDocument());
}

const printDocumentPolicy = () => (dispatch, getState) => {
  dispatch(hireCardViaTprintDocumentPolicy());
}

const hireCardViaTRequest = () => ({
  type: actionTypes.HIRE_CARD_VIA_T_REQUEST,
});

const hireCardViaTSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_VIA_T_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardViaTFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_VIA_T_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_VIA_T_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardViaT = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardViaTRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardViaTFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardViaTSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              VIA_T_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(VIA_T_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardViaTFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardViaTFailure());
      } else {
        throw response;
      }
    });
};

const hireCardViaT = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardViaT.getIn(['steps', SECOND_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        // todo nombreAdicional and nombreBeneficiario values
        nombreAdicional: '',
        nombreBeneficiario: '',
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: CREDIT_CARD_STANDARD_VIA_T,
          subTipo: CREDIT_CARD_SUBTYPE_VIA_T,
          tipo: CREDIT_CARD_TYPE_VIA_T,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: CREDIT_CARD_STANDARD_VIA_T,
        subType: CREDIT_CARD_SUBTYPE_VIA_T,
        type: CREDIT_CARD_TYPE_VIA_T,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardViaT(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving))
      .catch(response => {
        if (!!response.error) {
          setCardViaT(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};
const setCardViaTLimit = () => (dispatch) => {
  dispatch(hireCardCreditINE.getInitCardsDocuments());
}
const documentRead = (documentType) => (dispatch, getState) => {

  dispatch(hireCreditCardDocumentRead(documentType));
};
const onAcceptAllDocument = () => (dispatch, getState) => {
  dispatch(hireCreditCardAllDocumentRead());
};
const saveDocumentList = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCreditCardsaveDocumentAccepted(documentsList, dmsDocumentType, documentChanges));
};
const checkRadioButtonIneDir = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCardNerudaCheckedRadioButtonIneDir(documentsList, dmsDocumentType, documentChanges));
}
module.exports = {
  hireCardViaT,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
  checkRadioButton,
  printDocument,
  processEmail,
  onHandleChangeCheckBoxCC,
  myCardsTarjetasHire,
  printDocumentPolicy,
  checkRadioButtonPolicy,
  setCardViaTLimit,
  documentRead,
  onAcceptAllDocument,
  saveDocumentList,
  checkRadioButtonIneDir
};
